export const formatUrlWithProtocol = (url) => {
  if (!url) return '#'

  const protocolRegex = /^(https?:?\/?\/?)/i
  const urlFormated = url.replace(protocolRegex, '').trim()
  return `https://${urlFormated}`
}

export const appendQueryString = (url: string, params: Record<string, string | number | boolean>) => {
  const urlObj = new URL(url, window.location.origin)

  Object.entries(params).forEach(([key, value]) => {
    urlObj.searchParams.append(key, String(value))
  })

  return urlObj.toString()
}
